<template>
  <div v-if="linkArray && linkArray.length > 0">
    <div>
      <h6>🔗 资源推荐</h6>
      <div class="sidebar-box">
        <ul>
          <li v-for="link in linkArray" :key="link.id">
            <a :href="link.link" target="_blank">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      linkArray: []
    };
  },
  mounted: function() {
    this.fetchLinks();
  },
  methods: {
    fetchLinks: function() {
      this.$axios
        .get("/links")
        .then(response => (this.linkArray = response.data.data.slice(0, 10)));
    }
  }
};
</script>
<style scope>
.links {
  list-style: none;
}
</style>
